import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Modal, TextField } from "@mui/material";
import SlidingPanel from "react-sliding-side-panel";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";
import TextArea from "../../../Supporting files/TextArea/TextArea";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const BulkUploadForm: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [uploadFileStep, setUploadFileStep] = useState(1);
  const [uploadFile, setUploadFile] = useState(false);
  const [addPolicyStatus, setAddPolicyStatus] = useState(false);

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  // const changePageStatus = (status: boolean) => {
  //   if (status === true) {
  //     if (pageStatus < 2) {
  //       setPageStatus(pageStatus + 1);
  //     }
  //   } else {
  //     if (pageStatus > 1) {
  //       setPageStatus(pageStatus - 1);
  //     }
  //   }
  // };

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      panelClassName="sliding-panel"
      // backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={10}>
            <h4 className="mb-0 mt-3 text-left">Upload your Document</h4>
          </Grid>
          <Grid xs={2} textAlign="end" className="mt-3">
            <GridCloseIcon
              onClick={() => {
                value_update(attrName, false);
                setUploadFileStep(1);
              }}
            />
          </Grid>
          <Grid xs={12} className="mb-4 pt-0">
            <hr />
          </Grid>
        </Grid>
        <div className="scrollable_area">
          {uploadFileStep == 1 ? (
            <div>
              {/* <Grid container spacing={3}>
                <Grid xs={12}>
                  <h5 className="popup-heading mb-4">
                    Upload Employees in Bulk
                  </h5>
                </Grid>
              </Grid> */}
              <Grid
                container
                spacing={0}
                justifyContent="center"
                className="mb-5"
              >
                <Grid xs={10} className="inputField uploadFile">
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Upload .xl .csv .xls file"
                    variant="outlined"
                    className="textarea"
                  />
                </Grid>
                <Grid xs={2}>
                  <Button
                    variant="contained"
                    className="browsebtn"
                    component="label"
                  >
                    Browse
                    <input hidden accept="image/*" multiple type="file" />
                  </Button>
                </Grid>
                <Grid xs={12} className="inputField mb-4 mt-2">
                  <TextField
                    rows={3}
                    fullWidth
                    id="outlined-basic"
                    label="Describe here"
                    variant="outlined"
                    className="textarea"
                  />
                  {/* <TextArea
                    attrName={""}
                    class_name="inputField"
                    title="Describe here"
                    value={""}
                    value_update={updateMasterState}
                    warn_status={false}
                    error_messg=""
                  /> */}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => {
                      setUploadFileStep(2);
                    }}
                  >
                    Upload
                  </Button>
                </Grid>
              </Grid>
            </div>
          ) : (
            <h1></h1>
          )}
          {uploadFileStep == 2 ? (
            <div>
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <Link
                    className="close-button"
                    onClick={() => {
                      setUploadFile(false);
                    }}
                  />
                  <h5 className="popup-heading mb-4">Uploading file</h5>
                </Grid>
              </Grid>
              <Grid container spacing={0}>
                <Grid xs={12} className="mb-5">
                  <Box sx={{ flexGrow: 1 }}>
                    <LinearProgress variant="determinate" value={50} />
                  </Box>
                </Grid>
                <Grid xs={12} className="mb-5">
                  <Link className="md-link" underline="none">
                    67%... donot close or switch tab while it’s uploading
                  </Link>
                </Grid>
              </Grid>
            </div>
          ) : (
            <h1></h1>
          )}
          {uploadFileStep == 3 ? (
            <div>
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <Link
                    className="close-button"
                    onClick={() => {
                      setAddPolicyStatus(false);
                    }}
                  />
                  <h5 className="popup-heading">Kudos !!</h5>
                </Grid>
              </Grid>
              <Grid container spacing={0} textAlign="center">
                <Grid xs={12} className="mb-5">
                  <h1>Img</h1>
                </Grid>
                <Grid xs={12} className="mb-5">
                  <h5 className="popup-heading">You file has been uploaded</h5>
                </Grid>
              </Grid>
            </div>
          ) : (
            <h1></h1>
          )}
        </div>
      </div>
    </SlidingPanel>
  );
};

export default BulkUploadForm;
